<script>
  import { seriesNumber } from "./store.js";

  import Title from "./Title.svelte";
  import SubcategoryLink from "./SubcategoryLink.svelte";
  import Note from "./Note.svelte";
  import Strength from "./Strength.svelte";
  import CardList from "./CardList.svelte";
  import Blog from "./Blog.svelte";
  import SubMenu from "./SubMenu.svelte";

  const promise = getData();
  const tpath = themePath;
  const url = location.href;
  const pid = postId;

  /*
    ------------------------------------------
     productMasterを各シリーズごとに分類
    -----------------------------------------
  */
  let productMasterOrganized = [];
  let productMap = new Map();

  const organizeProductMaster = async () => {
    //サブカテゴリーを確定
    const extractSubcatNumber = () => {
      if (location.href.indexOf("subcat") !== -1) {
        const subcatNum = Number(location.href.split("subcat=")[1]);
        const productSeries = categoryInfo["subCategory"][subcatNum];
        return productSeries;
      } else {
        return categoryInfo["subCategory"][0];
      }
    };
    const subCategoryName = extractSubcatNumber();

    //必要なカテゴリーだけ絞り込み
    const thisCategoryMaster = categoryMaster.filter((x) => {
      return x.CATEGORY_PATH_2.value === subCategoryName;
    });

    //カテゴリーをMapに格納
    thisCategoryMaster.forEach((x) => {
      if (x.CATEGORY_PATH_3.value) {
        productMap.set(x.CATEGORY_PATH_3.value, []);
      }
    });

    //Mapにカテゴリごとのデータを格納
    productMaster.forEach((x) => {
      const thirdPath = x.CATEGORY_PATH_3.value;
      let newValue;
      if(productMap.has(thirdPath)){
        newValue = productMap.get(thirdPath).concat([x]);
      } else {
        return false
      }
      productMap.set(thirdPath, newValue);
    });

    //パスごとにデータを分類
    let container = {};
    productMaster.forEach((x) => {
      const thirdPath = x.CATEGORY_PATH_3.value;
      //有効なものだけ抽出
      if (x.VALID_INVALID.value === "有効") {
        if (thirdPath in container) {
          container[thirdPath].push(x);
        } else {
          container[thirdPath] = [];
          container[thirdPath].push(x);
        }
      }
    });
    productMasterOrganized = container;
  };
</script>

<svelte:head>
  <link rel="stylesheet" href={`${tpath}/js/bundle.css`} />
</svelte:head>

{#await promise}
  <p class="loading">loading</p>
{:then response}
  <section class="m_title">
    <div class="container">
      <div class="title">
        <Title {promise} {pid} />
      </div>
      <ul>
        <SubcategoryLink {url} {promise} />
      </ul>
    </div>
  </section>

  <section class="m_note">
    <div class="container">
      <Blog {tpath} {pid} />
    </div>
  </section>

  <section class="m_note">
    <div class="container">
      <Note {pid} />
    </div>
  </section>

  <div class="submenu">
    <div class="container">
      <SubMenu {organizeProductMaster} {productMap}/>
    </div>
  </div>

  <section class="m_itemlist">
    <div class="inner">
      <Strength {productMasterOrganized} {organizeProductMaster} />
      <CardList {promise} {url} {tpath} {organizeProductMaster} {productMap}/>
    </div>
  </section>
{/await}

<style>
  .m_title .container {
    justify-content: flex-start;
  }
</style>
